import { FFDecksFunctionRequest } from '../models/CloudFunction';
import { getAuth } from 'firebase/auth';
import { FIREBASE_FUNCTION_URL } from '../app-settings';
import axios from 'axios';
import { FFDecksV3Deck, FFDecksV3TournamentResponse } from '../models/FFDecksV3';
import { Identifiable } from '../models/Common';

export async function getFFDecksV3Tournament(id: string): Promise<FFDecksV3TournamentResponse> {
    try {
        if (!id) {
            return Promise.reject();
        }

        const auth = getAuth();
        if (!auth.currentUser) {
            return Promise.reject();
        }

        const request: FFDecksFunctionRequest<Identifiable> = {
            body: { id: id },
            functionName: "gettournament"
        }

        const userToken = await auth.currentUser.getIdToken();
        const response = await axios.post<FFDecksV3TournamentResponse>(`${FIREBASE_FUNCTION_URL}/ffdecks`, request, { headers: { Authorization: `Bearer ${userToken}` } });
        return response.data;
    } catch (e) {
        return Promise.reject("Error fetching ffdecks tournament.");
    }
}

export async function getFFDecksV3Deck(id: string): Promise<FFDecksV3Deck> {
    try {
        if (!id) {
            return Promise.reject();
        }

        const auth = getAuth();
        if (!auth.currentUser) {
            return Promise.reject();
        }

        const request: FFDecksFunctionRequest<Identifiable> = {
            body: { id: id },
            functionName: "getdeck"
        }

        const userToken = await auth.currentUser.getIdToken();
        const response = await axios.post<FFDecksV3Deck>(`${FIREBASE_FUNCTION_URL}/ffdecks`, request, { headers: { Authorization: `Bearer ${userToken}` } });
        return response.data;
    } catch (e) {
        return Promise.reject("Error fetching ffdecks tournament.");
    }
}